import React, { ReactElement } from 'react';
import useCurrentUser from 'hooks/useCurrentUser';
import { MedelyLogo } from '@medely/web-components/icons';
import { useTheme } from '@medely/web-components/themes';
import { ProArchived } from '@mp';

const ProArchivedView = (): ReactElement => {
  const { currentUser } = useCurrentUser();
  const theme = useTheme();

  return (
    <>
      <MedelyLogo color={theme.palette.primary.main} />
      <ProArchived archiveReason={currentUser?.professional?.archive_reason} />
    </>
  );
};

export default ProArchivedView;
